import styled from 'styled-components';

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 35px;
  margin-bottom: 14px;

  h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 1.2;
    color: #2f3d48;
    flex-shrink: 0;
    margin: 0;
    white-space: nowrap;

    @media (max-width: 1250px) {
      font-size: 20px;
    }
  }

  .divider {
    flex: 1;
    height: 2px;
    background: rgba(146, 156, 185, 0.3);
  }
`;

export const SectionSubtitle = styled.p`
  font-family: 'Poppins';
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0 0 16px;
`;

export const KpiRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const KpiCard = styled.div`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  padding: 20px 20px 20px 22px;
  box-sizing: border-box;
`;

export const KpiLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 8px;

  @media (min-width: 1800px) {
    font-size: clamp(16px, 1vw, 22px);
  }

  .icon {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }
`;

export const KpiValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;

  .value {
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 42px;
    line-height: 46px;
    color: #2f3d48;

    @media (min-width: 1800px) {
      font-size: clamp(42px, 1vw, 48px);
    }
  }

  .trend {
    font-family: 'Poppins';
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    color: #17c981;

    @media (min-width: 1800px) {
      font-size: clamp(16px, 1vw, 22px);
    }
  }

  .trend.negative,
  .trend.flat {
    color: #b3b9c2;
  }
`;

export const KpiCaption = styled.div`
  font-family: 'Poppins';
  font-size: 12px;
  color: #b3b9c2;
  margin-top: 6px;
`;

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const CardBase = styled.div`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  padding: 20px 20px 20px 22px;
  box-sizing: border-box;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .title {
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 16px;
    color: #000000;
  }

  .caption {
    font-family: 'Poppins';
    font-size: 12px;
    color: #b3b9c2;
  }
`;

export const SourceTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead th {
    text-align: left;
    font-family: 'Poppins';
    font-size: 12px;
    color: #b3b9c2;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0 0 12px;
    border-bottom: 1px solid #eef0f4;
  }

  thead th:not(:first-child) {
    text-align: right;
  }

  tbody td {
    padding: 12px 0;
    font-family: 'Poppins';
    font-size: 14px;
    color: #2f3d48;
    border-bottom: 1px solid #f9fafb;
  }

  tbody td:not(:first-child) {
    text-align: right;
    font-weight: 700;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const SourceCell = styled.div`
  .name {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .rank {
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Poppins';
    font-size: 12px;
    font-weight: 700;
    color: #b3b9c2;
  }

  .bar {
    height: 4px;
    border-radius: 2px;
    margin-top: 6px;
  }
`;

export const DonutWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const DonutContainer = styled.div`
  position: relative;
  width: 180px;
  height: 180px;
  flex-shrink: 0;

  svg,
  .recharts-wrapper,
  .recharts-surface {
    display: block;
  }

  @media (max-width: 767px) {
    align-self: center;
  }
`;

export const DonutCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;

  .big {
    font-family: 'Poppins';
    font-size: 24px;
    font-weight: 700;
    color: #2f3d48;
    line-height: 1.1;
  }

  .small {
    font-family: 'Poppins';
    font-size: 12px;
    color: #b3b9c2;
    margin-top: 2px;
  }
`;

export const DonutLegend = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  font-family: 'Poppins';
  font-size: 14px;
  color: #2f3d48;

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
  }

  .pct {
    margin-left: auto;
    font-weight: 700;
    font-size: 14px;
  }
`;
